export enum Buildings {
  GoldOreSmelter = 'gold_ore_smelter',
  Jewelry = 'jewelry',
  Dock = 'dock',
  BlackSmith = 'blacksmith',
  Sawmill = 'sawmill',
  ToymakerShop = 'toymaker_shop',
  Plantation = 'plantation',
  Warehouse = 'warehouse',
  Townhall = 'townhall',
  IronOreMine = 'iron_ore_mine',
  CoalMine = 'coal_mine',
  GoldOreMine = 'gold_ore_mine',
  IronOreSmelter = 'iron_ore_smelter',
  Tavern = 'tavern',
  Barbershop = 'barbershop',
  CeramicWorkshop = 'ceramic_workshop',
  GlassWorkshop = 'glass_workshop',
  ClayQuarry = 'clay_quarry',
  SandQuarry = 'sand_quarry',
  Seller = 'seller',
  ConstructionCamp = 'construction_camp',
  Dex = 'dex',
  WitchHut = 'witch_hut',
  Cave = 'cave',
  Forest = 'forest',
  Manor = 'manor'
}
